<template>
  <div class="container mt-30">
    <div class="row">
      <div class="col-lg-2 col-1"></div>
      <div class="col-lg-8 col-10">
        <div class="row">
          <div class="col-lg-12">
            <p
            ><span
            ></span>
            </p>
            <p
            >
              <strong><span
              >TÉRMINOS Y CONDICIONES DE USO DEL SITIO WEB </span></strong><span
            >https://www.chuspic.com</span><strong><span
            ></span></strong>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >Bienvenido a nuestros Términos y Condiciones que regulan el acceso y uso del sitio web cuyo Recurso Localizador Uniforme (URL) https://www.chuspic.com. Para hacer uso de la Plataforma digital de CHUSPIC es necesario que leas detenidamente y comprendas las disposiciones aquí contempladas para que puedas interactuar en la plataforma digital.</span>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <strong><span
              >INTRODUCCIÓN</span></strong><span

            ></span>
            </p>
            <p
            >
              <strong><span
              ></span></strong>
            </p>
            <p
            >
              <span
              >CHUSPIC<strong></strong></span><span

            >es una plataforma digital que ofrece, promociona, comercializa sus productos y presta sus servicios en línea por medio del Recurso Localizador Uniforme (URL) </span><span
            >https://www.chuspic.com</span><span
            >Las personas que deseen interactuar en la plataforma digital están sujetos a los siguientes Términos y Condiciones, y demás políticas y principios que la rigen. Por lo tanto, cualquier persona que desee acceder a la Plataforma digital, estará condicionada a la aceptación completa de los Términos y Condiciones estipulados y a la normatividad vigente en el momento en que la persona ingresa al sitio web con dominio </span><span
            ><a href="https://utcb.chuspic.com"
            >https://www.chuspic.com </a> </span><span
            > En caso de que no compartas o no estés de acuerdo con los Términos y Condiciones que rigen el funcionamiento de la plataforma digital, debes abstenerte de ingresar al sitio web toda vez que, CHUSPIC no se hace responsable del inadecuado uso de la plataforma digital.</span>
            </p>
            <p
            >
              <span
              >Si interactúas en la plataforma digital estas obligado a leer, entender y aceptar todas las disposiciones establecidas en los Términos y Condiciones, y demás lineamientos publicados aplicables a todos los productos y servicios, con sus respectivas modificaciones. Al inscribirte o usar de otra manera el servicio, o acceder a cualquier contenido o material publicado en la plataforma digital, estás celebrando un contrato vinculante con CHUSPIC, y por lo tanto aceptas los mismos y te obligas a su cumplimiento. En caso de que no puedas cumplir con las obligaciones aquí descritas, no utilices el servicio, ni el contenido de CHUSPIC.</span>
            </p>
            <p
            >
              <span
              >Las personas que decidan ingresar al sitio web desde otros países o que, en razón a su nacionalidad u origen, no se encuentren familiarizadas con las leyes mexicanas, aceptan expresamente sujetarse en todas sus relaciones contractuales y extracontractuales con CHUSPIC por las normas mexicanas. Por ello, cualquier controversia o reclamación que no pueda ser solucionada directamente por las partes, las mismas se someten expresamente a la jurisdicción de los Tribunales de la ciudad de Guadalajara, Jalisco, renunciando a cualquier otra que pudiera corresponderles por razón de su domicilio o cualquier otra circunstancia.</span>
            </p>
            <p
            >
              <span
              >Además, CHUSPIC no se hace responsable porque el contenido de la plataforma no sea adecuado en otros países, por lo que es responsabilidad del usuario acceder a este sitio web en países donde no esté prohibido.</span>
            </p>
            <p
            >
              <strong><span
              >DEFINICIONES</span></strong>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >Para efectos del presente contrato, el Usuario reconoce los siguientes conceptos, mismos que podrán utilizarse en singular o plural indistintamente y que se definen de la siguiente manera:</span>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <strong><span
              >CHUSPIC: </span></strong><span

            >Se refiere a la sociedad CHUSPIC, SAPI DE CV<strong></strong></span>
            </p>
            <p
            >
              <strong><span
              >Usuario:</span></strong><span

            >Es el comprador, quien realiza el pago del producto y/o servicio deseado.</span>
            </p>
            <p
            >
              <strong><span
              >Plataforma Digital:</span></strong><span

            >Sistema que permite la ejecución de las diversas aplicaciones dentro del entorno del sitio web de </span><span
            >https://www.chuspic.com</span><u><span
            ></span></u><span

            ></span>
            </p>
            <p
            >
              <strong><span
              >Medios de pago:</span></strong><span

            >Los productos y/o servicios ofrecidos serán pagados por los medios disponibles en la plataforma digital de acuerdo en los Términos y Condiciones de CHUSPIC.</span>
            </p>
            <p
            >
              <strong><span
              >Compras de productos:</span></strong><span

            >Cuando se realiza una compra, CHUSPIC procederá a enviar un correo electrónico de manera semi-automática desde la cuenta </span><span
            ><a href="mailto:info@chuspic.com"><span
            >info@chuspic.com</span></a></span><span

            > a la cuenta que el Usuario proporcione al darse de alta en la plataforma digital. En dicho correo se adjuntará un enlace el cual el Usuario deberá dar clic para que lo remita al servidor que le permita acceder, compartir y descargar su(s) fotografía(s) durante 1 un año.</span>
            </p>
            <p
            >
              <strong><span
              >Evento:</span></strong><span

            > El suceso importante y programado, de índole social, académico, artístico o deportivo del cual es organizado o es participante el Usuario.</span>
            </p>
            <p
            >
              <strong><span
              >Responsabilidades:</span></strong><span

            >Como Usuario, para interactuar en nuestra comunidad, debes actuar conforme a los Términos y Condiciones, asumiendo ciertas cargas o comportamientos necesarios para el correcto funcionamiento de nuestra plataforma digital.</span>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <strong><span
              >REGISTRO DEL USUARIO</span></strong>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >Para hacer uso de la plataforma digital de CHUSPIC, no es obligatorio que ingreses tus datos personales, pues te mantendrás como anónimo durante tu estancia en la plataforma digital. Sólo en el momento en que te registras como Usuario o realizas una compra de producto, tus datos personales, a excepción de tus datos financieros en caso de hacer la compra con tarjeta débito o crédito, quedan incorporados en nuestra base de datos, utilizándose únicamente para tramitar el pedido y para realizar el seguimiento. Si has dado tu consentimiento expreso, y en tanto no lo revoques, también se utilizaría para enviarte información comercial que te pueda interesar como promociones, cupones y novedades (favor de revisar nuestro <u>AVISO DE PRIVACIDAD</u>).</span>
            </p>
            <p
            >
              <span
              >Recuerda que para la realización de tus compras de productos a través del sitio web con dominio </span><span
            ><a href="https://2digital.chuspic.com"><span
            >https://www.chuspic.com</span></a></span><span

            > es necesario abrir una cuenta. Para abrir una cuenta, debes registrar tus datos personales y escoger una contraseña para su acceso. Lo anterior, te permitirá realizar compras y hacer seguimiento a las mismas.</span>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <strong><span
              >CAPACIDAD</span></strong>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >Agradecemos que quieras usar nuestros servicios o adquirir nuestros productos, pero debes tener en cuenta algunas limitantes sobre quiénes pueden usarlos o adquirir nuestros productos.</span>
            </p>
            <p
            >
              <span
              >No puedes usar nuestros servicios y/o realizar compras de productos:</span>
            </p>
            <ul type="disc">
              <li
              >
                <span
                >Si no tienes capacidad legal para contratar o suscribir un contrato vinculante con CHUSPIC.</span>
              </li>
              <li
              >
                <span
                >Si tienes 17 años o menos, deberás abstenerte de crear una cuenta, subir contenido o compartirnos información personal.</span>
              </li>
              <li
              >
                <span
                >Si se te ha prohibido usar nuestros servicios con anterioridad.</span>
              </li>
              <li
              >
                <span
                >Si eres representante legal de una persona jurídica, deberás tener capacidad plena para vincularla y obligarla legalmente.</span>
              </li>
            </ul>
            <p 
            >
              <span> </span><span

            >Si no eres organizador o participante del Evento en el cual se te proporciona un número de pedido para acceder, compartir y descargar tu(s) fotografía(s).</span>
            </p>
            <p 
            >
              <span> </span><span

            >Si no cuentas con tu número de competidor tratándose de evento deportivo.</span>
            </p>
            <p
            >
              <span
              >Si eres menor de edad, entendemos y aceptamos que tu representante legal ha consultado estos Términos y Condiciones, y los ha aceptado.</span>
            </p>
            <p
            >
              <strong><span
              >RECOLECCIÓN DE DATOS</span></strong>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >CHUSPIC recolecta los datos personales necesarios para la correcta prestación de los servicios requeridos por los Usuarios, a excepción de los datos financieros. Por lo tanto, el Usuario brindará los datos personales de identificación, ubicación, de contacto o de cualquier otro tipo al momento de la compra del producto. Estos datos personales recolectados tendrán como finalidad el uso (facturación y envío) y la adquisición de los productos ofrecidos por medio de la plataforma digital.</span>
            </p>
            <p
            >
              <span
              ><strong>OBLIGACIONES DE LOS USUARIOS</strong></span>
            </p>
            <ul type="disc">
              <li
              >
                <span
                >Realizar el registro con los datos correctos y verídicos, incluido número de competidor y/o pedido.</span>
              </li>
              <li
              >
                <span
                >Aceptar los Términos y Condiciones, los anexos emitidos por CHUSPIC y las demás políticas de privacidad y condiciones estipuladas.</span>
              </li>
              <li
              >
                <span
                >Aceptar las condiciones de venta incluidas en el acuerdo.</span>
              </li>
              <li
              >
                <span
                >Realizar la totalidad del pago del artículo o paquete de fotografías adquirido.</span>
              </li>
            </ul>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <strong><span
              >SERVICIOS Y/O PRODUCTOS</span></strong>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >Los servicios y/o productos ofrecidos por CHUSPIC son principalmente la venta de fotografías tomadas en un evento de índole social, académico, artístico o deportivo del cual es organizado o es participante el Usuario. Por ello, el Usuario que ingrese a la plataforma digital se sujeta a las condiciones del paquete de fotografías contratado por el organizador del evento. Adicionalmente, se le informa al Usuario que la(s) fotografía(s) que compre, será confirmado al correo electrónico que proporcionó al momento de darse de alta como Usuario, por lo que en dicho correo electrónico se le proporcionará un enlace que le permita entrar a nuestro servidor para descargar la(s) fotografía(s) comprada(s). El enlace proporcionado al Usuario tendrá una vigencia de 1 un año para que este pueda acceder, compartir y/o descargar su(s) fotografía(s). Vencido el término establecido, el Usuario no podrá acceder más a dicha(s) fotografía(s).</span>
            </p>
            <p
            >
              <strong><span
              >PAGO</span></strong>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >El precio que deberás pagar por cada paquete fotográfico y/o fotografía(s) será el precio vigente en la plataforma digital al momento de hacerse el pedido, o bien, el cotizado a través de </span><span
            ><a href="mailto:contacto@chuspic.com"><span
            >contacto@chuspic.com</span></a></span><span

            >, ya sea en pre-venta o posterior a la celebración del evento, por lo que CHUSPIC no garantiza mantener los precios de los paquetes fotográficos y/o fotografía(s) ni se hace responsable por los cambios de estos.</span>
            </p>
            <p
            >
              <span
              >En CHUSPIC te ofrecemos diferentes formas de realizar el pago de tus compras. Sólo es escoger la opción que te quede más cómoda y fácil, entre:</span>
            </p>
            <ul type="disc">
              <li
              >
                <span
                >Tarjeta de crédito o débito (mediante la plataforma STRIPE o CONEKTA).</span>
              </li>
              <li
              >
                <span
                >PayPal.</span>
              </li>
              <li
              >
                <span
                >Transferencia Bancaria. Para este método de pago, favor de comunicarte al correo electrónico </span><span
              ><a href="mailto:contacto@chuspic.com"><span
              >contacto@chuspic.com</span></a></span><span

              > (Aplica únicamente para el País México).</span>
              </li>
            </ul>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >En ningún caso CHUSPIC será responsable por las fallas que se presenten en las comunicaciones de las entidades bancarias o de crédito, así como tampoco de los perjuicios causados al Usuario con ocasión de una acción u omisión por parte de dichas entidades, como tampoco será responsable CHUSPIC por cualquier interrupción en la conexión que presente el Usuario.</span>
            </p>
            <p
            >
              <span
              >Una vez que CHUSPIC verifique el pago, podrá proceder a la aceptación de la oferta de compra. Sin embargo, a pesar de haberse verificado el pago, CHUSPIC podrá denegar la aceptación de una oferta de compra o aceptarla parcialmente, en cuyo caso sólo estará obligado a restituirle al Usuario, sin ningún tipo de interés o rendimiento, el valor cancelado por la oferta de compra no aceptada o el porcentaje correspondiente a la parte no aprobada de una oferta de compra aceptada parcialmente.</span>
            </p>
            <p
            >
              <span
              >Dentro de las alternativas que se contemplan en la plataforma digital para las compras de productos, se pone a disposición de los Usuarios un enlace que comunica con las respectivas plataformas de pago autorizadas por CHUSPIC. En tales situaciones, el manejo de la información personal y financiera será responsabilidad exclusiva de la plataforma de pagos y los Usuarios deberán aceptar sus Términos y Condiciones antes de realizar sus transacciones.</span>
            </p>
            <p
            >
              <span
              >Para las compras internacionales, los precios de las compras de productos están originalmente en pesos mexicanos (MXN), siendo la plataforma STRIPE, quien calculará el costo del producto a la moneda de cambio deseada por usted. Puedes pagar con tarjeta de débito o crédito que la plataforma de pagos STRIPE autorice. </span>
            </p>
            <p
            >
              <strong><span
              >ENTREGA DE LAS COMPRAS DE PRODUCTOS</span></strong>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >CHUSPIC te entregará el paquete fotográfico y/o fotografía(s) seleccionada(s) a través de un correo electrónico que se te envíe al correo electrónico que tienes vinculado con nosotros, correo electrónico que tendrá un enlace que te re direccionará a nuestro servidor donde podrás acceder, compartir y/o descargar las fotografía(s). Asegúrate de revisar que el correo electrónico te llegue a tu bandeja de entrada y/o spam. A su vez, es responsabilidad del Usuario verificar la cuenta de correo electrónico que dio de alta al momento de inscribirse como Usuario, ya que será a la cual se le envíe el enlace de acceso.</span>
            </p>
            <p
            >
              <strong><span
              >NOTA:</span></strong><span

            > Es posible que un mismo pedido se divida en varios enlaces para acceder a tu paquete de fotografías.</span>
            </p>
            <p
            >
              <strong><span
              >TIEMPOS DE ENTREGA</span></strong>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >Se te envía un enlace para acceder a tus compras de productos de manera semi automática al correo electrónico solicitado, desde la cuenta </span><span
            ><a href="mailto:info@chuspic.com"><span
            >info@chuspic.com</span></a></span><span

            >, correo electrónico que podrás recibir en un periodo de 48 cuarenta y ocho horas después de realizado el pedido y pago. En el caso concreto de los paquetes de pre-venta, se te enviará el correo electrónico con el enlace correspondiente para acceder a tus fotografías hasta 5 cinco días habiles después de celebrado el evento.</span>
            </p>
            <p
            >
              <span
              >El tiempo de entrega depende de muchos factores, como el día en que es aprobado el pago por tu banco, si cuentas con acceso a internet, entre otros.</span>
            </p>
            <p
            >
              <span
              >En caso de que no te llegue el correo electrónico, tienes problemas para acceder, compartir y/o descargar tus fotografías, o bien, tienes alguna duda, envíanos un correo electrónico a </span><span
            ><a href="mailto:contacto@chuspic.com"><span
            >contacto@chuspic.com</span></a></span><span

            >, mismo que se te responderá en un lapso de 36 horas. Se te comunica que CHUSPIC tiene una atención al cliente de lunes a viernes (</span><span

            >omitiendo días festivos según los señalados por la Ley Federal del Trabajo en México), en un horario de 9:00 a 14:00 horas y de 16:00 a 19:00 horas.</span><strong><span

            ></span></strong><span

            ></span>
            </p>
            <p
            >
              <strong><span
              >NOTA: DEBIDO A LAS NORMAS PROFERIDAS SOBRE EL AISLAMIENTO SANITARIO CON OCASIÓN AL COVID-19, TE SOLICITAMOS COMPRENSIÓN Y PACIENCIA ANTE CUALQUIER CONTRATIEMPO SUFRIDO POR ESTOS MOTIVOS.</span></strong><span

            ></span>
            </p>
            <p
            >
              <strong><span
              >CARACTERÍSTICA(S) DE LA(S) FOTOGRAFÍA(S)</span></strong>
            </p>
            <p
            >
              <strong><span
              ></span></strong>
            </p>
            <p
            >
              <span
              >CHUSPIC te hará entrega de tu paquete de fotografías en un archivo digital en alta resolución en formato .jpg, sin logotipos o edición, contando con una calidad mínima de 2500x1500 pixeles.</span>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <strong><span
              >DESCUENTOS</span></strong>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >CHUSPIC informa que algunos paquetes fotográficos contarán con un descuento, dependiendo del producto y/o evento, así como el ser cliente frecuente. Para más información, mandar un correo electrónico a la cuenta </span><span
            ><a href="mailto:contacto@chuspic.com"><span
            >contacto@chuspic.com</span></a></span><span

            >.</span>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <strong><span
              >REEMBOLSO</span></strong>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >CHUSPIC no realiza reembolsos por ningún motivo. En dado caso adquieras un paquete de fotografías para un evento del cual no pudiste participar, CHUSPIC te hará valido el paquete fotográfico contratado para tu siguiente evento, o bien, podrás transferir tu paquete fotográfico a otro participante de dicho evento en particular. Para más información, envíanos un correo electrónico a </span><span
            ><a href="mailto:contacto@chuspic.com"><span
            >contacto@chuspic.com</span></a></span><span

            >.</span>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <strong><span
              >PROHIBICIONES</span></strong>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >Está prohibido por las leyes vigentes y por CHUSPIC:</span>
            </p>
            <ul type="disc">
              <li
              >
                <span
                >Introducir datos personales falsos.</span>
              </li>
              <li
              >
                <span
                >Manipular los precios.</span>
              </li>
              <li
              >
                <span
                >Introducir dispositivos, como virus, que interfieran en las actividades o afecten el sitio web con dominio </span><span
              ><a href="https://2digital.chuspic.com"><span
              >https://www.chuspic.com </span></a></span><span

              >.</span>
              </li>
              <li
              >
                <span
                >Enviar correos electrónicos o mensajes que contengan o trasmitan algún tipo de virus para irrumpir con el normal funcionamiento de la página web con dominio </span><span
              >https://www.chuspic.com </span><span
              ></span>
              </li>
              <li
              >
                <span
                >Cualquier acto que ocasione daños o perjuicios al funcionamiento del sitio web dominio </span><span
              ><a href="https://2digital.chuspic.com"><span
              >https://www.chuspic.com </span></a></span><span

              >.</span>
              </li>
              <li
              >
                <span
                >Todo acto o evento contrario a las leyes mexicanas.</span>
              </li>
              <li
              >
                <span
                >Todo acto que induzca al consumidor al engaño por medio de publicidad u cualquier otro medio.</span>
              </li>
              <li
              >
                <span
                >Todo acto dañino, ilícito, amenazador, abusivo, acosador, difamatorio, prostitución, pornográfico, entre otros que invadan la privacidad de otros o dañen a menores de cualquier forma.</span>
              </li>
              <li
              >
                <span
                >Todo acto que interfiera con la seguridad del sitio web </span><span
              ><a href="https://2digital.chuspic.com"><span
              >https://www.chuspic.com </span></a></span><span

              >, como trasmitir o distribuir cualquier tipo de aviso o mensajes que contengan virus.</span>
              </li>
              <li
              >
                <span
                >Cualquier acto que infrinja derechos de propiedad intelectual sobre marcas registradas, secretos comerciales o industriales, o derechos de autor.</span>
              </li>
              <li
              >
                <span
                >Copiar, reproducir o utilizar la reputación o calificación del sitio web en cualquier ámbito.</span>
              </li>
              <li
              >
                <span
                >Agredir, difamar, insultar, acosar, intimidar a otra persona o entidad.</span>
              </li>
              <li
              >
                <span
                >Agredir, difamar, insultar, acosar, intimidar a otra persona respecto a su religión, genero, orientación sexual, raza, etnia, edad, discapacidad, clase, entre otros.</span>
              </li>
              <li
              >
                <span
                >Todo acto o producto que induzca al engaño, o a una falsa apariencia.</span>
              </li>
              <li
              >
                <span
                >Todo acto que genere ingeniería inversa al sitio web con dominio </span><span
              ><a href="https://2digital.chuspic.com"><span
              >https://www.chuspic.com </span></a></span><span

              >.</span>
              </li>
            </ul>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >De acuerdo con las prohibiciones contempladas anteriormente, el usuario que incurra en alguna de las prohibiciones mencionadas será investigado por CHUSPIC y sancionará al usuario con la terminación del servicio contratado o vinculo comercial.</span>
            </p>
            <p
            >
              <strong><span
              >NOTA:</span></strong><span

            > La lista presentada es enunciativa más no limitativa, por lo que CHUSPIC podrá considerar prohibido cualquier otro comportamiento dañino que realicen los usuarios, incluyendo los señalados por las leyes mexicanas vigente y sus posibles reformas.</span>
            </p>
            <p
            >
              <strong><span
              >PROPIEDAD INTELECTUAL</span></strong><span

            ></span>
            </p>
            <p
            >
              <span
              >El uso de nuestros productos está protegido por normas nacionales e internacionales, por lo que no te concede derechos de propiedad, interés o titularidad sobre los mismos, ni del contenido de otras personas que utilizan los servicios, marcas registradas, logotipos, derechos de autor, patentes, diseños industriales u otras características de CHUSPIC. El contenido de nuestros productos podrá usarse si te autoriza su titular por escrito o si está permitido por la ley. No elimines, ocultes ni alteres los avisos legales que se muestren en nuestros servicios ni en su contenido.</span>
            </p>
            <p
            >
              <span
              >Por lo anterior, deberás abstenerte en todo momento de:</span>
            </p>
            <ul type="disc">
              <li
              >
                <span
                >Utilizar los contenidos con fines contrarios a la ley, la moral, las buenas costumbres generalmente aceptadas o el orden público.</span>
              </li>
              <li
              >
                <span
                >Reproducir, copiar, distribuir, permitir el acceso del público a través de cualquier modalidad de comunicación pública.</span>
              </li>
              <li
              >
                <span
                >Suprimir, eludir o manipular cualquier clase de textos, leyendas o mensajes cuyo objeto sea la protección de los derechos de propiedad intelectual sobre los contenidos, así como los dispositivos técnicos de protección que pudieren contener los contenidos.</span>
              </li>
              <li
              >
                <span
                >Emplear los contenidos y, en particular, la información de cualquier clase obtenida a través de la plataforma para remitir publicidad y/o comunicaciones con fines de venta directa o con cualquier otra clase de finalidad comercial, mensajes no solicitados dirigidos a una pluralidad de personas con independencia de su finalidad, así como abstenerse de comercializar los contenidos.</span>
              </li>
              <li
              >
                <span
                >Deformar, mutilar o modificar de cualquier manera el material fotográfico que se le hace entrega, sin la autorización de CHUSPIC, con base en lo establecido en el artículo 21, fracción III de la Ley Federal del Derecho de Autor.</span>
              </li>
            </ul>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >Cualquier uso no autorizado de los contenidos de CHUSPIC dará lugar para que iniciemos las acciones legales necesarias para salvaguardar nuestros derechos.</span>
            </p>
            <p
            >
              <strong><span
              >VIOLACIÓN DE DERECHOS DE TERCEROS</span></strong><span

            ></span>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >En caso de que cualquier usuario o un tercero considere que cualquiera de los contenidos que CHUSPIC ha introducido en el sitio web con dominio </span><span
            ><a href="https://2digital.chuspic.com"><span
            >https://www.chuspic.com </span></a></span><span

            >, violan sus derechos de propiedad intelectual, dicho usuario o tercero deberá enviarnos al correo electrónico</span><span
            ><a href="mailto:contacto@chuspic.com"><span
            >contacto@chuspic.com </span></a></span><span

            >, en el que se informe lo siguiente:</span>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <ul type="disc">
              <li
              >
                <span
                >Datos personales: Nombre completo, dirección física, número de teléfono y dirección de correo electrónico del reclamante.</span>
              </li>
              <li
              >
                <span
                >Firma auténtica o equivalente, con los datos personales del titular de los derechos de propiedad intelectual supuestamente infringidos y/o de su apoderado.</span>
              </li>
              <li
              >
                <span
                >Indicación precisa y completa de los contenidos supuestamente infringidos, así como de su localización en el sitio web con dominio </span><span
              ><a href="https://2digital.chuspic.com"><span
              >https://www.chuspic.com </span></a></span><span

              >.</span>
              </li>
              <li
              >
                <span
                >Declaración expresa y clara de que la utilización de los contenidos indicados se ha realizado sin el consentimiento del titular de los derechos de propiedad intelectual supuestamente infringidos.</span>
              </li>
              <li
              >
                <span
                >Declaración expresa, clara y bajo la responsabilidad del reclamante de que la información proporcionada en la notificación es exacta y de que la utilización de los contenidos constituiría una violación de sus derechos de propiedad intelectual.</span>
              </li>
            </ul>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <strong><span
              >CAMBIOS Y MODIFICACIONES</span></strong>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >CHUSPIC revisará estas condiciones oportunamente y siempre publicaremos la versión más actualizada en nuestra página web con dominio </span><span
            >https://www.chuspic.com </span><span
            >Si una revisión reduce considerablemente tus derechos, te informaremos oportunamente (por ejemplo, a través de un mensaje a la dirección de correo electrónico vinculada a tu cuenta, en esta página, entre otros). Al continuar usando los servicios o al acceder a ellos después de la entrada en vigor de las revisiones, aceptas quedar legalmente vinculado, de conformidad con los Términos y Condiciones.</span>
            </p>
            <p
            >
              <strong><span
              >RESPONSABILIDAD DEL USUARIO</span></strong>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >El usuario responderá por los daños y perjuicios que CHUSPIC pueda sufrir, directa o indirectamente, como consecuencia del incumplimiento de estos Términos y Condiciones o de la ley. El Usuario reconoce y acepta que el acceso y utilización de la plataforma digital se realiza bajo su propia cuenta, riesgo y responsabilidad.</span>
            </p>
            <p
            >
              <span
              >El usuario será responsable por tomar medidas adecuadas y actuar diligentemente al momento de acceder al sitio web con dominio </span><span
            >https://www.chuspic.com </span><span
            >Parte de dicha diligencia implica tener programas de protección, antivirus, para manejo de malware, spyware y herramientas similares. Además, deberá tener copias de los programas y datos que tengan en el equipo mediante el cual accede al sitio web con dominio </span><span
            ><a href="https://2digital.chuspic.com"><span
            >https://www.chuspic.com </span></a></span><span

            >.</span>
            </p>
            <p
            >
              <span
              ><strong>RESPONSABILIDAD DE CHUSPIC</strong></span>
            </p>
            <p
            >
              <span
              >CHUSPIC ni sus respectivos empleados y terceros asociados garantizan que el uso de la plataforma digital no sufrirá interrupciones ni contendrá errores, ni garantiza la continuidad, disponibilidad ni buen funcionamiento del sitio web con dominio </span><span
            >https://www.chuspic.com </span><span
            >En consecuencia, en cualquier tiempo y sin previo aviso, CHUSPIC tienen facultad para bloquear, interrumpir o restringir el acceso a la plataforma digital sin que por ello se derive responsabilidad (contractual o extracontractual) alguna para nosotros.</span>
            </p>
            <p
            >
              <span
              >CHUSPIC no controla ni garantiza que los contenidos se encuentren libres de errores, virus u otros elementos de similar naturaleza que puedan producir alteraciones en el sistema informático del usuario (software y hardware) o en los documentos electrónicos y ficheros almacenados en el mismo. Bajo ninguna circunstancia, CHUSPIC ni sus relacionados serán responsables de ningún daño directo, indirecto, imprevisto, especial ni emergente que se genere, ya sea por el uso o falta de capacidad para usar el sitio web, incluidos los daños que surjan a raíz de su confianza en la información obtenida en la plataforma digital que ocasione errores, omisiones, interrupciones, eliminación o corrupción de archivos, virus, demoras en la operación o transmisión, o cualquier otro tipo de error en su funcionamiento que representen o no erogaciones patrimoniales.</span>
            </p>
            <p
            >
              <span
              >Además, CHUSPIC no garantiza la veracidad, exactitud, exhaustividad y actualidad de los contenidos ni garantiza la licitud, fiabilidad, utilidad y/o adecuación a un propósito concreto de la plataforma. Por ende, no será responsable por los daños y perjuicios que pudiera sufrir el Usuario con ocasión de las faltas o carencias de tales características.</span>
            </p>
            <p
            >
              <span
              >Por lo anterior, al ingresar al sitio web con dominio </span><span
            ><a href="https://2digital.chuspic.com"><span
            >https://www.chuspic.com </span></a></span><span

            >, aceptas en forma expresa que su uso se realiza bajo tu exclusiva responsabilidad y riesgo.</span>
            </p>
            <p
            >
              <strong><span
              >DENEGACIÓN Y RETIRADA DEL ACCESO AL SITIO</span></strong>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >CHUSPIC se reserva el derecho a denegar o retirar el acceso a la plataforma digital, en cualquier momento y sin necesidad de preaviso, a aquellos usuarios que incumplan estos Términos y Condiciones, o cualquier otra disposición que resulte de aplicación.</span>
            </p>
            <p
            >
              <strong><span
              >PUBLICIDAD</span></strong>
            </p>
            <p
            >
              <strong><span
              ></span></strong>
            </p>
            <p
            >
              <span
              >Las organizaciones, productos y/o servicios a los cuales CHUSPIC les haga publicidad en la plataforma digital, así como los enlaces (links), no son afiliados o tienen relación alguna con nosotros, por lo que no cumplimos ninguna función en la producción de esos productos y/o la prestación de servicios y no constituye ninguna garantía, expresa o implícita, de su contenido o de su adecuación para un propósito particular. Así, por ejemplo, cuando se sugiera la utilización de algún producto y/o servicio, es de tu exclusiva autonomía decidir su utilización, y por lo tanto CHUSPIC no asume ninguna responsabilidad por los perjuicios directos o indirectos, ciertos o eventuales, pasados, presentes o futuros, que se llegaren a derivar de dicha utilización.</span>
            </p>
            <p
            >
              <span
              >De esta forma, las transacciones que realices con terceros ajenos a CHUSPIC a partir de las publicidades de productos y/o servicios, así como las visitas que realices a sus sitios web a través de los vínculos (links) serán bajo tu exclusiva cuenta y riesgo, sin que de manera alguna comprometan la responsabilidad de CHUSPIC.</span>
            </p>
            <p
            >
              <strong><span
              >HIPERENLACES</span></strong>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >Los usuarios y, en general, todas aquellas personas que pretendan establecer un hiperenlace que desde sus páginas direccionen su navegador (Browser) al sitio web deberán cumplir con las siguientes condiciones:</span>
            </p>
            <ul type="disc">
              <li
              >
                <span
                >El hiperenlace únicamente permitirá el acceso a la página principal del sitio web con dominio </span><span
              ><a href="https://2digital.chuspic.com"><span
              >https://www.chuspic.com </span></a></span><span

              >.</span>
              </li>
              <li
              >
                <span
                >No se creará un browse, frame o borderenvironment sobre las páginas web del sitio.</span>
              </li>
              <li
              >
                <span
                >La inclusión del hiperenlace no tendrá como objeto o efecto que las páginas del sitio web sean mostradas en un sitio no controlado por CHUSPIC.</span>
              </li>
              <li
              >
                <span
                >No se realizarán manifestaciones o indicaciones falsas, inexactas o incorrectas sobre el sitio web, en particular, no se declarará ni dará a entender que CHUSPIC ha autorizado el hiperenlace o que ha supervisado o asumido de cualquier forma los contenidos o servicios ofrecidos o puestos a disposición en la página web que contiene el hiperenlace.</span>
              </li>
              <li
              >
                <span
                >A excepción hecha de aquellos signos que formen parte del mismo hiperenlace, la página web en la que se establezca el hiperenlace no contendrá ninguna marca, nombre comercial, rótulo de establecimiento, denominación, logotipo, eslogan u otros signos distintivos pertenecientes o licenciados a CHUSPIC.</span>
              </li>
              <li
              >
                <span
                >La página web en la que se establezca el hiperenlace no contendrá informaciones o contenidos ilícitos, contrarios a la moral y buenas costumbres generalmente aceptadas y al orden público, así como tampoco incluirá contenidos contrarios a cualesquiera derechos de terceros.</span>
              </li>
            </ul>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >El establecimiento del hiperenlace no tiene como objeto o efecto la creación de relaciones comerciales entre CHUSPIC y el propietario de la página web en la que se establezca dicho hiperenlace. Igualmente, el establecimiento del Hiperenlace en ningún caso tiene como objeto o efecto la aceptación, aprobación o apoyo por parte de CHUSPIC del sitio del tercero, o bien de los servicios y/o contenidos en él ofrecidos.</span>
            </p>
            <p
            >
              <strong><span
              >COOKIES</span></strong>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >Las cookies son pequeños archivos de datos que los sitios web como</span><span
            ><a href="https://2digital.chuspic.com"><span
            >https://www.chuspic.com </span></a></span><span

            > o los correos electrónicos guardan en su buscador y opcionalmente en el disco duro. Las cookies te permiten "recordar" la información sobre tus preferencias y sesión, y desplazarte dentro de las áreas de la plataforma sin volver a introducir sus datos.</span>
            </p>
            <p
            >
              <span
              >Esto hace posible crear una experiencia de compras más personalizada y cómoda. CHUSPIC usa un tercero para instalar cookies en tu ordenador para recopilar información que no sea personal e identificable. A pesar de que las cookies contienen un número único de usuario, no recopilan ni guardan ninguna información personal identificable.</span>
            </p>
            <p
            >
              <span
              >Aunque puedes configurar tu navegador de internet para que no aceptes cookies, éstas son necesarias para poder ver, crear una cuenta o hacer compras por medio del sitio web con dominio </span><span
            ><a href="https://2digital.chuspic.com"><span
            >https://www.chuspic.com </span></a></span><span

            >.</span>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >El buscador de internet recoge automáticamente información de la página web que hayas consultado antes de visitar la plataforma digital, el navegador que utilizó y cualquier término de búsqueda que haya ingresado en el sitio web, entre otras cosas. CHUSPIC también podrá usar otras tecnologías para rastrear las páginas que visitas para garantizarte una mejor y más segura experiencia de compra y para ayudarnos a entender cómo los visitantes usan nuestro sitio web.</span>
            </p>
            <p
            >
              <strong><span
              ></span></strong>
            </p>
            <p
            >
              <strong><span
              >LEY APLICABLE</span></strong>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >El presente acuerdo está regido por las leyes vigentes mexicanas. En consecuencia, todas las visitas y todos los contratos y transacciones que se realicen en el sitio web con dominio </span><span
            ><a href="https://2digital.chuspic.com"><span
            >https://www.chuspic.com </span></a></span><span

            >, así como sus efectos jurídicos, quedarán regidos por estas reglas y sometidos a la legislación aplicable en México.</span>
            </p>
            <p
            >
              <strong><span
              >COMUNÍCATE CON NOSOTROS</span></strong>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >CHUSPIC atiende a sus seguidores que necesiten realizar consultas o trámites en el correo electrónico</span><span
            ><a href="mailto:contacto@chuspic.com"><span
            >contacto@chuspic.com </span></a></span><span

            >, de lunes a viernes (</span><span

            >omitiendo días festivos según los señalados por la Ley Federal del Trabajo en México), en un horario de 9:00 a 14:00 horas y de 16:00 a 19:00 horas, o bien, a través de nuestro sitio web con dominio </span><span
            ><a href="https://2digital.chuspic.com/contacto"><span
            >https://www.chuspic.com/contacto </span></a></span><span

            >.</span><span

            ></span>
            </p>
            <p
            >
              <strong><span
              >AVISO DE PRIVACIDAD</span></strong>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >En cumplimiento de la Ley Federal de Protección de Datos en Posesión de los Particulares y su reglamento, hace de su conocimiento que CHUSPIC es responsable de recabar sus datos personales, del uso que se les dé a los mismos y de su protección, con la finalidad de evitar el tratamiento no autorizado, así como cualquier tipo de alteración, destrucción o daño de sus datos personales.</span>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <strong><span
              >TRATAMIENTO DE DATOS PERSONALES</span></strong><span

            ></span>
            </p>
            <p
            >
              <span
              >Nos permitimos informar que los datos personales que nos has entregado como titular de éstos, harán parte de nuestra base de datos para ser usados conforme a las finalidades primarias y secundarias expuestas en el <u>AVISO DE PRIVACIDAD</u>. De igual forma, CHUSPIC informa que los derechos que le asisten a los titulares son los contemplados en la Ley Federal de Protección de Datos Personales en Posesión de los particulares Capítulo III De los derechos de datos personales en posesión de los particulares Art. 22 al Art. 27 y Capítulo IV Del ejercicio de los derechos de Acceso, Rectificación, Cancelación y Oposición que corresponden del Art. 28 al Art. 35.</span>
            </p>
            <p
            >
              <span
              >Los datos personales de tus tarjetas suministrados por pagos con tarjeta débito o crédito son almacenados directamente por nuestro aliado de comercio electrónico Stripe y/ o Conekta.</span>
            </p>
            <p
            >
              <strong><span
              ></span></strong>
            </p>
            <p
            >
              <strong><span
              >FINALIDADES DEL TRATAMIENTO DE DATOS PERSONALES</span></strong>
            </p>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >El usuario que accede a la plataforma no está obligado a proporcionar información personal durante su visita al sitio web con dominio </span><span
            ><a href="https://2digital.chuspic.com"><span
            >https://www.chuspic.com </span></a></span><span

            >, pues permanecerá anónimo y no será identificado a menos que desee adquirir los productos ofrecidos.</span>
            </p>
            <p
            >
              <span
              >Los datos personales que el titular suministre en cualquiera de los formularios disponibles personalmente y de forma virtual, serán utilizados para la prestación del servicio solicitado y serán incorporados en una base de datos, cuya responsabilidad y manejo está a cargo de CHUSPIC para las siguientes finalidades:</span>
            </p>
            <p
            >
              <strong><span
              >Clientes</span></strong><span

            ></span>
            </p>
            <ul type="disc">
              <li
              >
                <span
                >Enviar al correo físico, electrónico, celular o dispositivo móvil, vía mensajes de texto (SMS y/o MMS) o a través de cualquier otro medio análogo y/o digital de comunicación, información comercial, publicitaria o promocional sobre los productos, eventos y/o promociones de tipo comercial, con el fin de impulsar, invitar, dirigir, ejecutar, informar y de manera general, llevar a cabo campañas, promociones o concursos de carácter comercial o publicitario, adelantados por la compañía, o bien, dar cumplimiento a las obligaciones y compromisos que se han contraído contigo.</span>
              </li>
              <li
              >
                <span
                >Enviar información relacionada con informes de servicios, facturación, recibos de pago, entre otros documentos relacionados con las relaciones comerciales.</span>
              </li>
              <li
              >
                <span
                >Efectuar análisis e investigaciones comerciales, estadísticas, de riesgos, de mercado, de calidad, interbancaria y financiera, entre otros.</span>
              </li>
              <li
              >
                <span
                >Formalizar procesos de contratación y efectuar la prestación del servicio o la entrega del producto adquirido.</span>
              </li>
              <li
              >
                <span
                >Realizar gestiones administrativas y financieras.</span>
              </li>
              <li
              >
                <span
                >Brindar el servicio de soluciones e inquietudes.</span>
              </li>
              <li
              >
                <span
                >Verificar tu identidad.</span>
              </li>
              <li
              >
                <span
                >Contactarte o enviarte notificaciones en caso de ser necesario. Respetamos tu preferencia en relación con las vías de contacto. Si no deseas recibir notificaciones por algún medio y solo por alguno en especial puedes contactarnos.</span>
              </li>
              <li
              >
                <span
                >Solicitar tu opinión por medios de comunicación y otros.</span>
              </li>
              <li
              >
                <span
                >Enviarte cupones de descuento o darte beneficios para futuras compras.</span>
              </li>
              <li
              >
                <span
                >Atender a los requerimientos de autoridades competentes.</span>
              </li>
              <li
              >
                <span
                >Atender a obligaciones legales en la conservación de documentos.</span>
              </li>
              <li
              >
                <span
                >Dar trámite y respuesta a las solicitudes, quejas y reclamos presentados por los titulares.</span>
              </li>
              <li
              >
                <span
                >Administrar comunicaciones internas.</span>
              </li>
              <li
              >
                <span
                >Tener acceso a los datos biométricos de clientes a través de cualquier medio tecnológico y/o electrónico.</span>
              </li>
              <li
              >
                <span
                >Las demás finalidades necesarias para el desarrollo del objeto social de la compañía y la prestación de sus servicios.</span>
              </li>
            </ul>
            <p
            >
              <span
              ></span>
            </p>
            <p
            >
              <span
              >La anterior categorización se realiza con fines ilustrativos, pero el responsable del tratamiento tendrá la libertad de utilizar la información personal de acuerdo con todas las finalidades, indiferentemente si la persona se considere cliente, proveedor, empleado u otra calidad.</span>
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-1"></div>
    </div>
  </div>
</template>


<script>


export default {
  name: "TermsConditionsChuspic",

}
</script>

<style scoped>
</style>
